import React, { Fragment } from 'react'
import { Field, ErrorMessage } from 'formik'
import FieldError from './FieldError'
import { Checkbox as ZuiCheckbox } from 'components/Zui'

export const Checkbox = props => {
    return (
        <Fragment>
            {!props.noLabel && (
                <div className="form-label">
                    <span>{props.label || props.name}</span>
                </div>
            )}
            <Field component={CheckboxComponent} {...props} />
            {!props.noError && <ErrorMessage name={props.name} component={FieldError} />}
        </Fragment>
    )
}

const CheckboxComponent = ({ field, form, children, value, ...props }) => {
    const { onBlur, onChange, value: fieldValue, ...fieldProps } = field
    const { setFieldTouched, setFieldValue } = form
    return (
        <ZuiCheckbox
            {...fieldProps}
            emphasis="selected-primary"
            onInput={({ target }) => {
                if (typeof fieldValue === 'boolean') {
                    setFieldValue(field.name, target.value)
                } else if (typeof fieldValue === 'object') {
                    if (!target.value) {
                        setFieldValue(
                            field.name,
                            fieldValue.filter(_ => _ !== value)
                        )
                    } else {
                        setFieldValue(field.name, [...fieldValue, value])
                    }
                }
                setFieldTouched(field.name, true)
            }}
            {...props}
            value={Boolean(fieldValue.includes(value))}
        >
            {children}
        </ZuiCheckbox>
    )
}
